/**
 * Centre of the mirrored tree: the champion trophy (top), the Final box, and the bronze-final box,
 * stacked around the track's vertical centre so both halves' Semi-finals meet the Final dead centre.
 */

import React, { useMemo } from 'react'
import { View, Text } from 'react-native'
import { Trophy } from 'lucide-react-native'
import { useTheme } from '../../../src/theme/useTheme'
import type { BracketMatch } from '../../../src/knockout/types/knockoutBracket.types'
import { centerStyles, trackStyle } from '../../../src/knockout/helpers/bracketGeometry.helper'
import { BRACKET_TROPHY_SIZE } from './knockoutBracket.constants'
import { KnockoutMatchBox } from './KnockoutMatchBox'
import { getBracketCenterStyles } from './BracketCenter.styles'

interface BracketCenterProps {
  trackH: number
  final: BracketMatch | null
  thirdPlace: BracketMatch | null
}

export const BracketCenter: React.FC<BracketCenterProps> = ({ trackH, final, thirdPlace }) => {
  const theme = useTheme()
  const styles = useMemo(() => getBracketCenterStyles(theme), [theme])
  const pos = centerStyles(trackH)

  return (
    <View style={[styles.column, trackStyle(trackH)]}>
      <View style={pos.trophy}>
        <View style={styles.trophyWrap}>
          <Trophy size={BRACKET_TROPHY_SIZE} color={theme.gray[300]} strokeWidth={1.25} />
          <Text style={styles.trophyMark}>?</Text>
        </View>
        <Text style={styles.championLabel}>CHAMPION</Text>
      </View>

      {final != null ? (
        <View style={pos.final}>
          <KnockoutMatchBox match={final} badge="final" testID="knockout-final" />
        </View>
      ) : null}

      {thirdPlace != null ? (
        <View style={pos.bronze}>
          <KnockoutMatchBox match={thirdPlace} badge="bronze" testID="knockout-third-place" />
        </View>
      ) : null}
    </View>
  )
}
